// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__18_xT","topBottomGutter":"Layout_topBottomGutter__1WdrK"};